module.exports = __webpack_public_path__ + "img/app-title.319cd4d8.png";